/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';
import { JournalImageSize } from 'src/common/types/api/v4/search/v1/landing';
import styles from './JournalImg.module.scss';

const journalImageToSrcSet = (size: JournalImageSize, index: number): string => (
  `${size.url} ${index + 1}x`
);

type JournalImgProps = {
  alt: string;
  sizes: JournalImageSize[];
};

/**
 * A custom img component for images that are returned from the Journal api.
 *
 * Prefer using `<Img />` where possible.
 *
 * This component exists for a couple of reasons:
 * - The journal images uses different src urls for different sizes. It doesn't
 * support the query param approach to specifying image sizes (unlike reef).
 * - Images served from journal use their own domain, and therefore is not compatible
 * with the current approach to replacing the domain with reef domains.
 *
 * The creation of this component avoids adding additional complexity to the `Img`
 * component to handle these edge cases.
 */
const JournalImg: FC<JournalImgProps> = ({
  alt, sizes,
}) => {
  if (!sizes || sizes.length === 0) {
    return null;
  }

  return (
    <div className={styles.imageContainer}>
      <div className={styles.image}>
        <img
          alt={alt}
          srcSet={sizes.map(journalImageToSrcSet).join(', ')}
          src={sizes[0].url}
          width={sizes[0].width}
          height={sizes[0].height}
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default JournalImg;
